import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Icon, TooltipHost } from '@fluentui/react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const ItemCard = (props) => {
    const { 
        inputParam_Object = null,
    } = props;

    const { t } = useTranslation();

	const circleStyle = {
		width: "40px",
		height: "40px",
		backgroundColor: inputParam_Object.circleColor,
		borderRadius: '50%',
		padding: '10px',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	};

  	return (
		<>
			<Col className='col-auto ms-auto pe-1'>
				<div style={circleStyle}>
					<Icon iconName={inputParam_Object.iconName} style={{ fontSize: "20px", color: inputParam_Object.iconColor }} />
				</div>
			</Col>
			<Col>
				<Row>
					<Col className='ps-1'>
						<Row>
							<Col>
								<TooltipHost content={ inputParam_Object.title } calloutProps={{ gapSpace: 0 }} style={{overflow: "hidden", whiteSpace: "nowrap"}} styles={{ root: { display: 'inline-block' } }} >
									<div>{ t(inputParam_Object.title) }</div>
								</TooltipHost>
							</Col>
							<Col className='col-auto ms-auto'>
								<TooltipHost content={ inputParam_Object.date } >
									<Icon iconName="Calendar" style={{ fontSize: "14px" }} />
								</TooltipHost>
							</Col>
						</Row>
					</Col>
				</Row>
				<Row>
					<Col className='ps-1' style={{fontSize: "12px"}}>
						<TooltipHost content={ inputParam_Object.text } >
							<div>{ `${t('data-lang-lbl-kpi')}: ${inputParam_Object.text}` }</div>
                        </TooltipHost>
						<div>{ `${t('data-lang-lbl-user')}: ${inputParam_Object.username}` }</div>
					</Col>
				</Row>
			</Col>
		</>
  	);
};

ItemCard.propTypes = {
	inputParam_Object: PropTypes.object.isRequired,
};

export default ItemCard;